import { EstadosContratoChoiceEnum } from '@/shared';
import { ChipModelState } from '@/shared/components/ui';
import { Contrato } from '@/shared/interfaces';
import { calcContractStateColor } from '../utils';

export type ContractStateChipProps = {
  contract: Contrato;
  widthChip?: string;
};

const ContractStateChip: React.FC<ContractStateChipProps> = ({
  contract,
  widthChip = '70%',
}) => {
  const contractState = contract?.estado_contrato as EstadosContratoChoiceEnum;

  if (!contract || !contractState) return 'N/A';

  return (
    <>
      <ChipModelState
        label={contractState}
        color={calcContractStateColor(contractState) as any}
        sxChip={{
          width: widthChip,
          textAlign: 'center',
          py: 2,
          // px: 3,
          fontWeight: 500,
          fontSize: '14px',
        }}
      />
    </>
  );
};

export default ContractStateChip;
